import { createSlice } from '@reduxjs/toolkit';
import { FetchingTypes } from '../interfaces';

interface BrandPublicationState {
  post: {
    fetching: FetchingTypes;
    data: any;
    error: {
      code: string;
      message: string;
    };
  };
  update: {
    fetching: FetchingTypes;
    data: any;
    error: {
      code: string;
      message: string;
    };
  };
  images: {
    fetching: FetchingTypes;
    data: any[];
    error: any;
  };
}

const initialState: BrandPublicationState = {
  post: {
    fetching: "unknown",
    data: null,
    error: {
      code: "",
      message: ""
    }
  },
  update: {
    fetching: "unknown",
    data: null,
    error: {
      code: "",
      message: ""
    }
  },
  images: {
    fetching: "unknown",
    data: [],
    error: null
  }
};

const brandPublicationSlice = createSlice({
  name: 'brandPublication',
  initialState,
  reducers: {
    // Crear brand publication
    brandPublicationPostRequest: (state) => {
      state.post.fetching = "loading";
      state.post.error = { code: "", message: "" };
    },
    brandPublicationPostSuccess: (state, action) => {
      state.post.fetching = "success";
      state.post.data = action.payload;
    },
    brandPublicationPostFailure: (state, action) => {
      state.post.fetching = "failure";
      state.post.error = action.payload || { code: "UNKNOWN_ERROR", message: "Ha ocurrido un error" };
    },
    brandPublicationCleanPost: (state) => {
      state.post = initialState.post;
    },
    
    // Actualizar brand publication
    brandPublicationUpdateRequest: (state) => {
      state.update.fetching = "loading";
      state.update.error = { code: "", message: "" };
    },
    brandPublicationUpdateSuccess: (state, action) => {
      state.update.fetching = "success";
      state.update.data = action.payload;
    },
    brandPublicationUpdateFailure: (state, action) => {
      state.update.fetching = "failure";
      state.update.error = action.payload || { code: "UNKNOWN_ERROR", message: "Ha ocurrido un error" };
    },
    brandPublicationCleanUpdate: (state) => {
      state.update = initialState.update;
    },
    
    // Imágenes
    brandPublicationImagesPostRequest: (state) => {
      state.images.fetching = "loading";
    },
    brandPublicationImagesPostSuccess: (state, action) => {
      state.images.fetching = "success";
      state.images.data.push(action.payload);
    },
    brandPublicationImagesPostFailure: (state, action) => {
      state.images.fetching = "failure";
      state.images.error = action.payload;
    },
    brandPublicationCleanImages: (state) => {
      state.images = initialState.images;
    }
  }
});

export const {
  brandPublicationPostRequest,
  brandPublicationPostSuccess,
  brandPublicationPostFailure,
  brandPublicationCleanPost,
  brandPublicationUpdateRequest,
  brandPublicationUpdateSuccess,
  brandPublicationUpdateFailure,
  brandPublicationCleanUpdate,
  brandPublicationImagesPostRequest,
  brandPublicationImagesPostSuccess,
  brandPublicationImagesPostFailure,
  brandPublicationCleanImages
} = brandPublicationSlice.actions;

export default brandPublicationSlice.reducer;
